module.exports = __webpack_public_path__ + "img/biaoqian_zhanlanguan.14df5e6e.png";